import { RootState } from '@/app/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectTravelFilter = (state: RootState) => state.travelFilter

export const travelFilterSelector = createSelector(selectTravelFilter, (state) => state)
